import type { SettingsSource } from '../models/settings-hub.model';

import { field } from './settings-builders';
export const DELIVERY_SUBCATEGORY: SettingsSource = {
    id: 'delivery-takeaway',
    cards: [
        {
            id: 'delivery-takeaway',
            settings: [
                field.toggle('orders.disable_take_away_add_customer', 'SETTINGS.SETTINGS.DISABLE_TAKE_AWAY_ADD_CUSTOMER'),
                field.toggle('orders.disable_delivery_add_customer', 'SETTINGS.SETTINGS.DISABLE_DELIVERY_ADD_CUSTOMER'),
                field.toggle('orders.allow_street_only_shipping_addresses', 'SETTINGS.SETTINGS.ALLOW_STREET_ONLY_SHIPPING_ADDRESSES'),
                field.toggle('cashregister.ask_shipping_address', 'SETTINGS.SETTINGS.ASK_SHIPPING_ADDRESS'),
                {
                    id: 'orders.return_tables_takeaway_delivery',
                    preferenceKey: 'orders.return_tables_takeaway_delivery',
                    control: 'toggle',
                    label: 'SETTINGS.SETTINGS.GO_TO_TABLES_TAKEAWAY_DELIVERY',
                    disabledWhen: ({ values }) => !values['orders.open_tables_after_send']
                }
            ]
        }
    ]
};
